if (!customElements.get('ae-anthem')) {
  customElements.define('ae-anthem', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-anthem-interest]');
        if (!trigger) return;
        const select = this.querySelector('#AnthemInterest');
        if (!select) return;
        const option = Array.from(select.options).find(item => item.value === trigger.dataset.anthemInterest);
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  });
}





